export const useScripts = () => ({
  getOrderedDateRange(date) {
    let ordered_date = []
    if (date[0]) {
      if (date[1]) {
        if (date[0] > date[1]) {
          ordered_date.push(date[1])
          ordered_date.push(date[0])
        } else {
          ordered_date.push(date[0])
          ordered_date.push(date[1])
        }
      } else ordered_date.push(date[0])
    }
    return ordered_date
  },
  // Convert a Vuetify local-midnight Date to a 'YYYY-MM-DD' backend string. Correcting by the
  // *selected date's own* offset keeps its calendar day intact (local midnight would otherwise roll
  // back a day once UTC-shifted) and stays correct across DST — using today's offset would misformat
  // dates on the other side of a DST boundary. Shared so a range's start/end can never drift apart.
  toBackendDate(date) {
    if (!date) return ''
    const d = new Date(date)
    return new Date(d - d.getTimezoneOffset() * 60000).toISOString().substr(0, 10)
  },
  getBCP47LanguageCode(language) {
    switch (language) {
      case 'ar':
        return 'ar-SA'
      case 'cs':
        return 'cs-CZ'
      case 'da':
        return 'da-DK'
      case 'de':
        return 'de-DE'
      case 'en':
        return 'en'
      case 'es':
        return 'es'
      case 'fi':
        return 'fi-FI'
      case 'fr':
        return 'fr-FR'
      case 'he':
        return 'he-IL'
      case 'hu':
        return 'hu-HU'
      case 'id':
        return 'id-ID'
      case 'it':
        return 'it-IT'
      case 'ja':
        return 'ja-JP'
      case 'ko':
        return 'ko-KR'
      case 'nl':
        return 'nl-NL'
      case 'no':
        return 'no-NO'
      case 'pl':
        return 'pl-PL'
      case 'pt':
        return 'pt-PT'
      case 'ro':
        return 'ro-RO'
      case 'ru':
        return 'ru-RU'
      case 'sk':
        return 'sk-SK'
      case 'sv':
        return 'sv-SE'
      case 'th':
        return 'th-tH'
      case 'tr':
        return 'tr-TR'
      case 'zhHant':
        return 'zh-HK'
      case 'zhHans':
        return 'zh-CN'
      default:
        return 'en'
    }
  }
})
